<div class="content">
  <div app-feed-card
       [name]="'STUDENT_PILOT_NEWS'"
       [background]="'https://dl.videos.sportys.com/onlinecourse/images/SPN_blog.jpg'"
  ></div>
  <div app-feed-card
       [name]="'IPAD_PILOT_NEWS'"
       [background]="'https://dl.videos.sportys.com/onlinecourse/images/IPN_blog.jpg'"
  ></div>
</div>
